{
  "el": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Αλλαγή εικόνας σύνδεσης",
        "new": "Νέος Οργανισμός",
        "setAsPrimary": "Ορισμός ως κύρια",
        "submit": "Υποβολή",
        "undoChanges": "Αναίρεση αλλαγών"
      },
      "attributes": {
        "address": "Διεύθυνση",
        "aftercare_conversation_enabled": "Συνομιλίες παρατηρήσεων",
        "backgroundImage": "Εικόνα οθόνης σύνδεσης",
        "email_address": "Email",
        "email_address_invoicing": "Email τιμολόγησης",
        "email_address_renewal": "Email υπενθύμισης ανανέωσης συμβολαίου",
        "email_address_reply_to": "Διεύθυνση email απάντησης (Reply-to)",
        "email_address_ziggu": "Διεύθυνση email «From»",
        "iban": "IBAN",
        "language": "Γλώσσα",
        "languages": "Γλώσσες οργανισμού",
        "name": "Όνομα",
        "phone": "Τηλέφωνο",
        "storage_sum": "Χρήση αποθηκευτικού χώρου",
        "storage_sum_max": "{percentage}% από {gigabytes} GB",
        "subdomain": "Υποτομέας",
        "timezone": "Ζώνη ώρας",
        "vat_number": "Αριθμός ΦΠΑ"
      },
      "client_types": {
        "architects_designers": "Αρχιτέκτονες & Σχεδιαστές",
        "creative_agencies": "Δημιουργικά γραφεία",
        "general_specialized_contractors": "Γενικοί & Εξειδικευμένοι Εργολάβοι",
        "makers_manufacturers": "Κατασκευαστές & Παραγωγοί",
        "planners_coordinators": "Σχεδιαστές & Συντονιστές",
        "property_developers": "Εταιρείες Ανάπτυξης Ακινήτων"
      },
      "integrations": {
        "api_docs_info": "Για περισσότερες πληροφορίες σχετικά με το API μας, επισκέψου το",
        "api_documentation": "Τεκμηρίωση API"
      },
      "labels": {
        "activeProjects": "Ενεργά έργα",
        "activeProjectsUsed": "{0} ενεργά έργα, {1} μη χρησιμοποιημένα ακόμη",
        "activeUnits": "Ενεργά ακίνητα",
        "activeUnitsUsed": "{0} ενεργά ακίνητα, {1} μη χρησιμοποιημένα ακόμη",
        "after_care_categories": "Κατηγορίες",
        "after_care_statuses": "Καταστάσεις",
        "aftercare": "Παρατηρήσεις",
        "bookADemo": "Κλείσιμο demo",
        "by": "Από {client}",
        "categories": "Κατηγορίες",
        "category": "Κατηγορία",
        "chatWithUs": "Συνομιλία μαζί μας",
        "companyProfile": "Προφίλ οργανισμού",
        "contactIntercom": "Επικοινώνησε μαζί μας μέσω του chat αν θέλεις να το αλλάξεις.",
        "contactZiggu": "Έχεις μια ερώτηση για τη Ziggu; Κόλλησες κάπου; Θες συμβουλές για το προϊόν; Ας τα πούμε.",
        "conversations": "Συνομιλίες",
        "dashboard": "Αρχική",
        "decisions": "Αποφάσεις",
        "default_payment_overdue": "Έχεις ένα ληξιπρόθεσμο τιμολόγιο για τη Ziggu. Εξόφλησέ το άμεσα για να αποφύγεις τόκους. Έχεις ερωτήσεις; Επικοινώνησε μαζί μας.",
        "delete_category": "Διαγραφή κατηγορίας «{category}»;",
        "delete_category_expl": "Η διαγραφή κατηγορίας εγγράφων δεν μπορεί να αναιρεθεί. Τα υπάρχοντα έγγραφα με αυτή την κατηγορία θα αλλάξουν σε κατηγορία «Άλλο»",
        "document_categories": "Κατηγορίες",
        "documents": "Έγγραφα",
        "email_address_invoicing_info": "Θα στέλνουμε τα νέα τιμολόγια σε αυτή τη διεύθυνση.",
        "email_address_renewal_info": "Θα στέλνουμε email σε αυτή τη διεύθυνση όταν πλησιάζει η ημερομηνία ανανέωσης της συνδρομής σου, μαζί με όλες τις απαραίτητες πληροφορίες.",
        "email_address_reply_to": "Αυτή η διεύθυνση email θα χρησιμοποιείται όταν κάποιος απαντήσει σε email που στάλθηκε μέσω {email_address_ziggu}. Επικοινώνησε μαζί μας μέσω του chat αν θέλεις να το αλλάξεις.",
        "email_address_ziggu": "Αυτή η διεύθυνση email θα χρησιμοποιείται ως η διεύθυνση αποστολέα (FROM) όλων των email που στέλνονται μέσω της πλατφόρμας (email σχετικά με ειδοποιήσεις, προσκλήσεις, επαναφορές κωδικού πρόσβασης κ.λπ.)",
        "email_forwarder_must_be_owner": "Μόνο τα μέλη της ομάδας με ρόλο «Ιδιοκτήτης» μπορούν να προωθούν email.",
        "email_forwarding_activated": "Η προώθηση email είναι ενεργή",
        "email_forwarding_activated_project": "Η προώθηση email του έργου είναι ενεργή",
        "email_forwarding_disclaimer": "Για την αποφυγή ανεπιθύμητων μηνυμάτων, επεξεργαζόμαστε μόνο email που στέλνονται από διεύθυνση συνδεδεμένη με <b>υπαρκτό προφίλ Ιδιοκτήτη/Διαχειριστή έργου</b>.<br>Τα email από άγνωστους αποστολείς θα αγνοούνται.",
        "email_forwarding_is": "Η διεύθυνση προώθησής σου είναι",
        "financials": "Οικονομικά",
        "general": "Γενικά",
        "goToSettings": "Ρυθμίσεις",
        "helpcenter": "Κέντρο βοήθειας",
        "inbound_email": "Εισερχόμενο email",
        "invoice_overdue": "Έχεις μία εκπρόθεσμη πληρωμή. Επικοινώνησε στο accounting{'@'}ziggu.io για περισσότερες πληροφορίες.",
        "invoice_overdue_title": "Εκπρόθεσμο τιμολόγιο",
        "language": "Αυτή είναι η προεπιλεγμένη γλώσσα του οργανισμού για τη σελίδα σύνδεσης, τους πελάτες και τα μέλη της ομάδας σου.",
        "languages": "Η κύρια γλώσσα είναι η προεπιλογή για την εισαγωγή περιεχομένου και δεν μπορεί να αφαιρεθεί. Πρόσθεσε επιπλέον γλώσσες για να υποστηρίξεις πολύγλωσσο περιεχόμενο. Κάνε κλικ σε οποιαδήποτε επιπλέον γλώσσα για να την ορίσεις ως κύρια.",
        "mobile_app_disabled": "Εφαρμογή για κινητά (PWA) ανενεργή",
        "mobile_app_enabled": "Εφαρμογή για κινητά (PWA) ενεργή",
        "mobile_app_info": "Στείλε μας μήνυμα στο Intercom για περισσότερες πληροφορίες",
        "mustBeJPG": "Πρέπει να είναι εικόνα .jpg",
        "new_categories": "Επιπλέον κατηγορίες",
        "new_document_category": "Κατηγορία",
        "noCategories": "Δεν έχεις ακόμη καμία κατηγορία. Δημιούργησε μία για να ξεκινήσεις.",
        "other": "Άλλο",
        "outOfOffice": "Εκτός γραφείου",
        "outOfOfficeMessage": "Μήνυμα εκτός γραφείου (προαιρετικό)",
        "packageUnits": "Συνδρομή για",
        "primary": "Κύρια",
        "removed_user": "Αφαιρεμένος χρήστης",
        "settings": {
          "click_to_copy": "Κάνε κλικ για αντιγραφή του token στο πρόχειρο",
          "copied_to_clipboard": "Το token αντιγράφηκε στο πρόχειρο"
        },
        "snippets": "Αποσπάσματα",
        "subscription": "Συνδρομή",
        "subscriptionRenewalDate": "Ημερομηνία ανανέωσης",
        "subscriptionUsageUnits": "Τρέχουσα χρήση",
        "tab_aftercare": "Παρατηρήσεις",
        "tab_billing": "Χρεώσεις",
        "tab_branding": "Οπτική ταυτότητα",
        "tab_features": "Λειτουργίες",
        "tab_general": "Γενικά",
        "tab_information": "Πληροφορίες",
        "tab_integrations": "Ενσωματώσεις",
        "tickets": "Συνομιλίες",
        "timezone": "Αυτή είναι η προεπιλεγμένη ζώνη ώρας του οργανισμού.",
        "translation_not_added_yet": "Δεν έχει προστεθεί μετάφραση ακόμη",
        "unchangeable_categories": "Προεπιλεγμένες κατηγορίες που δεν μπορούν να αλλάξουν",
        "unchangeable_categories_info": "Αυτές οι κατηγορίες είναι απαραίτητες για τη σωστή λειτουργία του συστήματος ή χρησιμοποιούνται σε ενσωματώσεις.",
        "upgradePackageContactUs": "Επικοινώνησε μαζί μας για να ξεκινήσεις",
        "upgradePackageSubtitleAftercare": "Αυτή η λειτουργία σου επιτρέπει να παρακολουθείς τους πελάτες μετά την παράδοση και να τους βοηθάς να λύσουν τυχόν παρατηρήσεις για το νέο τους σπίτι",
        "upgradePackageSubtitleConversationMentions": "Αυτή η λειτουργία σου επιτρέπει να γράφεις ιδιωτικές σημειώσεις και να αναφέρεις μέλη της ομάδας σε μια συνομιλία",
        "upgradePackageSubtitleFinancials": "Δημιούργησε άμεσα μια οικονομική επισκόπηση για κάθε αγοραστή",
        "upgradePackageSubtitleMilestones": "Αυτή η λειτουργία σου επιτρέπει να ενημερώνεις εύκολα τον πελάτη σου για την πρόοδο της κατασκευής",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Αυτή η λειτουργία σου επιτρέπει να προσκαλέσεις έναν δεύτερο αγοραστή στην πλατφόρμα Ziggu",
        "upgradePackageTitle": "Φαίνεται πως δεν έχεις ακόμη αυτή τη λειτουργία",
        "warningooo": "Εκτός γραφείου",
        "yourEmail": "Το email σου",
        "zigguHome": "Αρχική Ziggu"
      },
      "project_types": {
        "mup": "MUP",
        "mup_and_sup": "MUP και SUP",
        "sup": "SUP"
      },
      "toasts": {
        "attachment_category": {
          "create": "Η κατηγορία εγγράφων δημιουργήθηκε",
          "update": "Η κατηγορία εγγράφων ενημερώθηκε"
        }
      },
      "validation": {
        "attachment_category_required": "Η κατηγορία είναι υποχρεωτική",
        "duplicated_translation": "Διπλότυπη μετάφραση",
        "mustBeEmailAddress": "Πρέπει να είναι διεύθυνση email",
        "needName": "Το όνομα είναι υποχρεωτικό"
      }
    }
  }
}
